// extracted by mini-css-extract-plugin
export default {"outer":"AdvancedCard_outer__8R7Mq"};